import { render } from "./PokemonPage.vue?vue&type=template&id=5b84aab8"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=5b84aab8&lang=css"

import exportComponent from "/home/trimogesimo/a-subir/Pokemon_Game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__